module.exports = __webpack_public_path__ + "img/navigate.bc8c35e8.svg";